<template>
  <div class="px-10">
    <v-expansion-panels
      v-model="panel"
      multiple
      class="elevation-2"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
          {{ section }} 
          <employee-profile-general-info-emergency-contact-dialog-create
            v-if="panel.length > 0 && $hasPermissionTo(['create emergency contacts']) && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @created="loadEmergencyContacts"
          />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="emergencyContacts"
            hide-default-footer
            dense
            class="border mt-4"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.relationship.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.relationship.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.contact_no="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.contact_no }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <employee-profile-general-info-emergency-contact-dialog-edit
                v-if="$hasPermissionTo(['update emergency contacts']) && !loading && !isMyProfile && !isResigned"
                :emergency-contact="item"
                @updated="loadEmergencyContacts"
              />
              <employee-profile-general-info-emergency-contact-dialog-delete
                v-if="$hasPermissionTo(['delete emergency contacts']) && !loading && !isMyProfile && !isResigned"
                :emergency-contact="item"
                @deleted="loadEmergencyContacts"
              />
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoEmergencyContactDialogCreate: () => import('@/components/hris/employee/profile/general-info/emergency-contact/DialogCreate'),
      EmployeeProfileGeneralInfoEmergencyContactDialogEdit: () => import('@/components/hris/employee/profile/general-info/emergency-contact/DialogEdit'),
      EmployeeProfileGeneralInfoEmergencyContactDialogDelete: () => import('@/components/hris/employee/profile/general-info/emergency-contact/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        section: 'Emergency Contacts',
        emergencyContacts: [],
        headers: [
          { 
            text: 'Name', 
            align: 'left',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Relationship',
            align: 'left',
            sortable: false,
            value: 'relationship.name',
          },
          { 
            text: 'Contact No.',
            align: 'left',
            sortable: false,
            value: 'contact_no',
          },
          { 
            text: '',
            sortable: false,
            value: 'action', 
          },
        ],
        loading: false,
        panel: [0],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmergencyContacts()
          }
        },
      },
    },
  
    methods: {
      loadEmergencyContacts () {
        this.loading = true

        this.$api.emergencyContacts().list(this.employeeUid)
          .then(res => {
            this.emergencyContacts = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}
</style>
